"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAppFlavourReducer = exports.updateAppFlavourReducer = exports.createAppFlavourReducer = exports.fetchAppFlavourReducer = exports.deleteAppFlavourSlice = exports.updateAppFlavourSlice = exports.createAppFlavourSlice = exports.fetchAppFlavourSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const appFlavourAction_1 = require("./appFlavourAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
const deleteInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.fetchAppFlavourSlice = (0, toolkit_1.createSlice)({
    name: 'appFlavour/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(appFlavourAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(appFlavourAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(appFlavourAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.createAppFlavourSlice = (0, toolkit_1.createSlice)({
    name: 'appFlavour/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(appFlavourAction_1.create.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(appFlavourAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(appFlavourAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.updateAppFlavourSlice = (0, toolkit_1.createSlice)({
    name: 'appFlavour/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(appFlavourAction_1.update.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(appFlavourAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(appFlavourAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.deleteAppFlavourSlice = (0, toolkit_1.createSlice)({
    name: 'appFlavour/delete',
    initialState: deleteInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(appFlavourAction_1.deleteApp.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(appFlavourAction_1.deleteApp.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(appFlavourAction_1.deleteApp.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.fetchAppFlavourReducer = exports.fetchAppFlavourSlice.reducer;
exports.createAppFlavourReducer = exports.createAppFlavourSlice.reducer;
exports.updateAppFlavourReducer = exports.updateAppFlavourSlice.reducer;
exports.deleteAppFlavourReducer = exports.deleteAppFlavourSlice.reducer;
